import React from 'react';
import { Collapse } from '@isyc-react/design/bootstrap';
export const SideBar = props => {
    const { open, onChange, children } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(Collapse, { in: open },
            React.createElement("div", { id: 'overlay', onClick: () => {
                    onChange && onChange(!open);
                } })),
        React.createElement(Collapse, { in: open },
            React.createElement("div", { className: 'd-xl-block sidebar overflow-auto', id: 'menu' }, children))));
};
